import dayjs from 'dayjs';
import { weeklyPlannerDayDisplayFormat } from 'tsx/libs/dayjs';

import { buildColumn, EditableColumnConfig } from '~components/table-view';

// Columns for Rescheduled Appointments
const rescheduledColumnsList: EditableColumnConfig[] = [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'date',
    header: 'New Date',
    type: 'date',
    accessorFn: (row) => dayjs(row.date).format(weeklyPlannerDayDisplayFormat),
  },
  {
    id: 'user.full_name',
    header: 'User',
    type: 'text',
  },
];

// Columns for Cancelled Appointments
const cancelledColumnsList: EditableColumnConfig[] = [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'date',
    header: 'Cancelled Date',
    type: 'date',
  },
  {
    id: 'user.full_name',
    header: 'User',
    type: 'text',
  },
];

export const rescheduledColumns = rescheduledColumnsList.map(buildColumn);
export const cancelledColumns = cancelledColumnsList.map(buildColumn);
